import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.version = this.route.snapshot.params['version']
    //this.list.push(new Terms('1.1', '2024-11-31'))
    this.list.push(new Terms('1.0', '2024-10-31'))
    //this.list.push(new Terms('0.9', '2024-10-01'))
    if(!this.version) {
      this.version = this.list[0].version
    }
    this.http.get('assets/terms/terms-' + this.version + '.html', {responseType: 'text'}).subscribe(res => {
      this.termsHtml = this.sanitizer.bypassSecurityTrustHtml(res.toString())
    })
  }
  version: string
  user: User
  list: Terms[] = new Array()
  termsHtml: SafeHtml
  ngOnInit(): void {
    this.user = this.commonService.getUserInfo()
  }
  logout(){
    this.authService.logout()
  }
  otherVersion: string = ''
  changeVersion() {
    if(this.otherVersion != '') {
      this.router.navigateByUrl('/terms/' + this.otherVersion)
    }
  }
  moveJoin() {
    window.scrollTo(0, 0);
    this.router.navigate(['/join'])
  }

  openGuideWindow() {
    var width = 1400 //screen.availWidth - 150
    var height = 800 //screen.availHeight - 250
    var windowPopup = window.open('/guide', 'guideWindow', 'width='+width/13*11+',height='+height+',left='+width/13*4+',top=0,scrollbars=no');
    windowPopup.focus();
  }
}

export class Terms {
  version: string
  regDate: string
  constructor(version: string, regDate: string) {
    this.version = version
    this.regDate = regDate
  }
}
